import { css } from '@emotion/react'
import theme from '../theme'
export default css`
    .ant-modal .ant-modal-content,
    .ant-modal .ant-modal-content .ant-modal-header {
        background-color: ${theme.colors.background.main};
    }

    .ant-dropdown.ant-dropdown-placement-bottomRight .ant-dropdown-menu {
        background-color: #37333e;
    }
`
